var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap justify-center"},_vm._l((_vm.buttons),function(button){return _c('Soundbutton',{key:button.name,attrs:{"file":button.file,"name":button.name,"nieuw":button.new}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }